import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React, { Component } from 'react';
import { withStyles, createStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import cx from 'classnames';
import DataIcon from './DataIcon';
/**
 * @extends {React.Component<import('./types').DataItemProps  & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */

var DataItem =
/*#__PURE__*/
function (_Component) {
  _inherits(DataItem, _Component);

  function DataItem() {
    _classCallCheck(this, DataItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(DataItem).apply(this, arguments));
  }

  _createClass(DataItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          collectionType = _this$props.collectionType,
          isTextOnly = _this$props.isTextOnly,
          name = _this$props.name,
          classes = _this$props.classes,
          xpath = _this$props.xpath;
      var iconType = 'field';

      if (type === 'element') {
        if (collectionType === 'single') iconType = 'single-element';else if (collectionType === 'split') iconType = 'split-element';else if (collectionType === 'multiple') iconType = 'multiple-element';
        if (isTextOnly) iconType = 'field';
      }

      return React.createElement("div", {
        title: xpath,
        className: classes.root
      }, React.createElement(Typography, null, React.createElement("span", {
        className: classes.itemIcon
      }, React.createElement(DataIcon, {
        type: iconType
      })), React.createElement("span", {
        className: cx(classes.itemText, iconType !== 'field' && classes.element)
      }, name)));
    }
  }]);

  return DataItem;
}(Component);

var styles = function styles() {
  return createStyles({
    root: {
      padding: '0px 16px 0px 2px',
      cursor: 'pointer',
      fontSize: 14,
      fontFamily: '"Calibri (Body)", Segoe, "Segoe UI", Candara, Optima, Arial, sans-serif',
      lineHeight: '30px',
      height: 32,
      whiteSpace: 'nowrap'
    },
    itemIcon: {
      marginRight: 2,
      verticalAlign: 'middle',
      display: 'inline-block',
      width: 24,
      textAlign: 'center'
    },
    itemText: {
      lineHeight: '30px'
    },
    element: {
      fontWeight: 'bold'
    }
  });
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECDataItem'
})(DataItem);